import { classifyZone } from "@/lib/shipping";

// Aree Condizioni di vendita: 2 macro-aree (Italia+Europa → europa, resto → extra_ue).
export function classifySalesZone(country) {
  return classifyZone(country) === "extra_ue" ? "extra_ue" : "europa";
}

const DEFAULT_TIERS = [
  { min: 0, max: 2500, discount: "35" },
  { min: 2500.01, max: 5000, discount: "40" },
  { min: 5000.01, max: null, discount: "40+5" },
];

export const DEFAULT_SALES_CONDITIONS = {
  zones: [
    { key: "europa", label: "Europa (Italia inclusa)", tiers: DEFAULT_TIERS.map((t) => ({ ...t })) },
    { key: "extra_ue", label: "Oltreoceano / Extra UE", tiers: DEFAULT_TIERS.map((t) => ({ ...t })) },
  ],
};

// "35" → [35]; "40+5" → [40,5]; [40,5] → [40,5]
export function parseDiscountExpr(expr) {
  const vals = Array.isArray(expr) ? expr : String(expr ?? "").replace(/%/g, "").replace(/,/g, ".").split("+");
  const out = [];
  for (const v of vals) {
    const f = parseFloat(String(v).trim());
    if (!Number.isNaN(f) && f > 0) out.push(f);
  }
  return out;
}

export function discountFactor(discounts) {
  return (discounts || []).reduce((f, d) => f * (1 - Number(d) / 100), 1);
}

export function effectivePct(discounts) {
  return Math.round((1 - discountFactor(discounts)) * 10000) / 100;
}

// Scaglione a soglia progressiva: l'ultimo con min <= importo.
export function tierForAmount(tiers, amount) {
  let selected = null;
  const sorted = [...(tiers || [])].sort((a, b) => (Number(a.min) || 0) - (Number(b.min) || 0));
  for (const t of sorted) {
    if (Math.round(amount * 100) / 100 >= (Number(t.min) || 0)) selected = t;
  }
  return selected || null;
}

export function computeVolumeDiscount(country, grossExcl, config) {
  const cfg = config && config.zones ? config : DEFAULT_SALES_CONDITIONS;
  const zoneKey = classifySalesZone(country);
  const zone = cfg.zones.find((z) => z.key === zoneKey) || cfg.zones[0];
  const tier = tierForAmount(zone?.tiers, grossExcl);
  const discounts = tier ? (Array.isArray(tier.discounts) ? tier.discounts : parseDiscountExpr(tier.discount)) : [];
  const factor = discountFactor(discounts);
  const amount = Math.round(grossExcl * (1 - factor) * 100) / 100;
  return {
    zoneKey,
    zoneLabel: zone?.label || "",
    discounts,
    expr: tier ? (tier.discount || discounts.join("+")) : "0",
    effectivePct: effectivePct(discounts),
    amount,
    factor,
    net: Math.round((grossExcl - amount) * 100) / 100,
  };
}
